export { default as SocialProofSection } from './SocialProofSection';